module.exports = "/_next/static/images/logo-black-dec8a7b4f2e6d15198ca7fa0e8937825.svg";